import styled from 'styled-components';
import colors from 'constants/colors';

export const HeaderContainer = styled.header`
  position: fixed;
  top: 0;
  display: flex;
  width: 100%;
  height: 50px;
  background: ${colors.black1};
  justify-content: flex-end;
  align-items: center;
  border-bottom: 1px solid ${colors.dimGrey};
  z-index: 1000;

  .headerTitle {
    position: absolute;
    display: flex;
    align-items: center;
    left: 15px;
    line-height: 50px;
    font-size: 19px;
    font-weight: 300;
    color: ${colors.white};
    text-decoration: none;
    cursor: pointer;

    @media only screen and (max-width: 1200px) {
      left: 10px;
    }
    
    .highlight {
      margin-left: 10px;
      margin-right: 5px;
      font-weight: bold;
    }
  }

  ${(props) => (props.mobile? props.open? `
      position: fixed;
      top: 0;
      @media only screen and (min-width: 1200px){
        display: none;
      }
    `:`display: none;`: null)};    

  ${(props) => props.additionalstyle};
`;

export const Alerts = styled.div`
  width: 37px;
  height: 49px;
  position: absolute;
  top: 0px;
  right: 54px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => (props.active ? colors.black2: colors.black1)};

  img {
    width: 19px;
    height: 21px;
    cursor: pointer;
    ${(props) => (props.active ?`filter: brightness(0) saturate(100%) invert(100%) sepia(100%) saturate(0%) hue-rotate(288deg) brightness(102%) contrast(102%);`: null)};
  }

  @media only screen and (max-width: 1200px) {
    display: none;
  }
`;

export const Messages = styled.div`
  width: 46px;
  height: 49px;
  position: absolute;
  top: 0px;
  right: 91px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => (props.active ? colors.black2: colors.black1)};

  img {
    width: 27px;
    height: 23px;
    cursor: pointer;
    ${(props) => (props.active ?`filter: brightness(0) saturate(100%) invert(100%) sepia(100%) saturate(0%) hue-rotate(288deg) brightness(102%) contrast(102%);`: null)};
  }
  
  @media only screen and (max-width: 1200px) {
    display: none;
  }
`;